import script from "./Divisions.vue?vue&type=script&setup=true&lang=js"
export * from "./Divisions.vue?vue&type=script&setup=true&lang=js"

import "./Divisions.vue?vue&type=style&index=0&id=0a7c7b22&lang=css"

const __exports__ = script;

export default __exports__